import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
    alertContainer: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        gap: 2
    },
    divider: {
        height: '3px',
    }
}))